import { Navigate } from "react-router-dom";

// Authentication related pages
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import ResetPassword from "../pages/Authentication/ResetPassword";

// Core pages
import Dashboard from "../pages/Dashboard/index";

import TrainingRequestList from "../pages/Training/TrainingRequestList";
import TrainingRequestCreate from "../pages/Training/TrainingRequestCreate";
import TrainingRequestDetail from "../pages/Training/TrainingRequestDetail";

import TrainingEvaluationList from "../pages/Training/TrainingEvaluationList";
import TrainingEvaluationDetail from "../pages/Training/TrainingEvaluationDetail";

import TravelDashboard from "../pages/Travel/TravelDashboard";
import TravelRequestCreateStep1 from "../pages/Travel/TravelRequestCreateStep1";
import TravelRequestCreateStep2 from "../pages/Travel/TravelRequestCreateStep2";
import TravelRequestCreateStep3 from "../pages/Travel/TravelRequestCreateStep3";
import TravelRequestCreateStep4 from "../pages/Travel/TravelRequestCreateStep4";
import TravelRequestCreateStep5 from "../pages/Travel/TravelRequestCreateStep5";
import TravelRequestDetail from "../pages/Travel/TravelRequestDetail";

import ClaimModuleList from "../pages/Claim/ClaimModuleList";
import ClaimCreateSelectType from "../pages/Claim/ClaimCreateSelectType";

import ClaimCreateCash from "../pages/Claim/ClaimCreateCash";
import ClaimCreateCreditCard from "../pages/Claim/ClaimCreateCreditCard";
import ClaimCreateLocalTravel from "../pages/Claim/ClaimCreateLocalTravel";
import ClaimCreateOverseasTravel from "../pages/Claim/ClaimCreateOverseasTravel";
import ClaimCreateMealAllowance from "../pages/Claim/ClaimCreateMealAllowance";
import ClaimCreateMileage from "../pages/Claim/ClaimCreateMileage";
import ClaimDetail from "../pages/Claim/ClaimDetail";

import ApprovalPage from "../pages/Approval/ApprovalPage";

import Settings from "../pages/Settings";
import Report from "../pages/Report";
import SelloutReport from "../pages/Report/SelloutReport";
import UserProfile from "../pages/UserProfile/UserProfile";
import Notification from "../pages/Notification";
import NotificationDetails from "../pages/Notification/NotificationDetails";
import ComingSoon from "../pages/Utility/ComingSoon";

// Utility pages
import Error404 from "../pages/Utility/Error404";
import Maintenance from "../pages/Utility/Maintenance";
import NotAuthorized from "../pages/Utility/NotAuthorized";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/profile", component: <UserProfile title={"Profile"} /> },

  // Travel & Budget
  { path: "/travel", component: <TravelDashboard /> },
  { path: "/travel/create", component: <TravelRequestCreateStep1 /> },
  { path: "/travel/create/step-1", component: <TravelRequestCreateStep1 /> },
  { path: "/travel/create/step-2", component: <TravelRequestCreateStep2 /> },
  { path: "/travel/create/step-3", component: <TravelRequestCreateStep3 /> },
  { path: "/travel/create/step-4", component: <TravelRequestCreateStep4 /> },
  { path: "/travel/create/step-5", component: <TravelRequestCreateStep5 /> },
  { path: "/travel/:id", component: <TravelRequestDetail /> },

  {
    path: "/training/request",
    component: <TrainingRequestList />,
  },
    {
      path: "/training/request/create",
      component: <TrainingRequestCreate />,
    },
    {
      path: "/training/request/:id",
      component: <TrainingRequestDetail />,
    },
    {
      path: "/training/evaluations",
      component: <TrainingEvaluationList />,
    },
    {
      path: "/training/evaluations/:id",
      component: <TrainingEvaluationDetail />,
    },

  {
    path: "/claim",
    component: <ClaimModuleList />,
  },
  {
    path: "/claim/create",
    component: <ClaimCreateSelectType />,
  },
    {
      path: "/claim/create/cash",
      component: <ClaimCreateCash />,
    },
    {
      path: "/claim/create/credit-card",
      component: <ClaimCreateCreditCard />,
    },
    {
      path: "/claim/create/local-travel",
      component: <ClaimCreateLocalTravel />,
    },
    {
      path: "/claim/create/overseas-travel",
      component: <ClaimCreateOverseasTravel />,
    },
    {
      path: "/claim/create/meal",
      component: <ClaimCreateMealAllowance />,
    },
    {
      path: "/claim/create/mileage",
      component: <ClaimCreateMileage />,
    },
    {
      path: "/claim/:id",
      component: <ClaimDetail />,
    },

    { path: "/approval", component: <ApprovalPage /> },
    
  { path: "/finance", component: <ComingSoon title="Finance" /> },

  // Notification
  { path: "/notification", component: <Notification title={"Notification"} /> },
  { path: "/notification/:ID", component: <NotificationDetails title={"View Notification"} /> },

  // Administration
  { path: "/settings", component: <Settings /> },

  // Reports
  { path: "/report", component: <Report title={"Reports"} /> },
  { path: "/report/:ID", component: <SelloutReport title={"Reports"} /> },

  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/reset-password", component: <ResetPassword /> },
  { path: "/maintenance", component: <Maintenance /> },
  { path: "/404", component: <Error404 /> },
  { path: "/not-authorized", component: <NotAuthorized /> },
];

export { authProtectedRoutes, publicRoutes };
